import { withStyles, makeStyles } from '@material-ui/core/styles';
import { default as mSlider } from '@material-ui/core/Slider';
import { default as mButton } from '@material-ui/core/Button';
import { default as mInput } from '@material-ui/core/Input';
import { mainColor } from '../../utils/palette';
const markStyle = {
  height: '25px',
  width: '6px',
  color: '#ccc',
  top: '2px'
}

export const Slider = withStyles({
  root: {
    color: 'grey',
    height: 8,
    '& > span.MuiSlider-markLabel[data-index="0"]': {
      transform: "translateX(0%)"
    },
    '& > span.MuiSlider-markLabel[data-index="1"]': {
      transform: "translateX(-90%)"
    }
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: mainColor,
    border: 0,
    boxShadow: '2px 2px #ccc',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  mark:{
    ...markStyle
  },
  markActive:{
    ...markStyle,
    opacity: 1,
    background: '#ccc'
  },
  markLabelActive:{
    color: mainColor,
    opacity: 1,
  },
  markLabel:{
    color: mainColor,
  },
  active: {},
  valueLabel: {
    left: 0,
  },
  track: {
    height: 5,
    borderRadius: 0,
    background: '#ccc'
  },
  rail: {
    height: 5,
    borderRadius: 0,
  },
})(mSlider);

export const TenorSlider = withStyles({
  root: {
    color: 'grey',
    height: 8,
    '& > span.MuiSlider-markLabel[data-index="0"]': {
      transform: "translateX(0%)"
    },
    '& > span.MuiSlider-markLabel[data-index="6"]': {
      transform: "translateX(-90%)"
    },
    '& > span.MuiSlider-mark[data-index="1"]': {
      display: "none"
    },
    '& > span.MuiSlider-mark[data-index="2"]': {
      display: "none"
    },
    '& > span.MuiSlider-mark[data-index="3"]': {
      display: "none"
    },
    '& > span.MuiSlider-mark[data-index="4"]': {
      display: "none"
    },
    '& > span.MuiSlider-mark[data-index="5"]': {
      display: "none"
    }
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: mainColor,
    border: 0,
    boxShadow: '2px 2px #ccc',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  mark:{
    ...markStyle
  },
  markActive:{
    ...markStyle,
    opacity: 1,
    background: '#ccc'
  },
  markLabelActive:{
    color: mainColor,
    opacity: 1,
  },
  markLabel:{
    color: mainColor,
  },
  active: {},
  valueLabel: {
    left: 0,
  },
  track: {
    height: 5,
    borderRadius: 0,
    background: '#ccc'
  },
  rail: {
    height: 5,
    borderRadius: 0,
  },
})(mSlider);

export const ApplyButton = withStyles({
  root: {
    height: '60px',
    position: 'absolute',
    bottom: '0',
    left: '50%',
    transform: 'translateX(-50%)',
    borderRadius: '25px',
    border: 'solid 1px #e4e2e7',
    margin: 0,
    padding: '3px',
    display: 'flex',
    alignItems: 'center',
    background: 'linear-gradient(0deg, rgba(15,60,86,1) 0%, rgba(17,105,169,1) 50%)',
    width: '200px',
    marginTop: 'auto',
    marginBottom: 'auto',
    letterSpacing: '5px'
  },
  label: {
    fontSize: '2em',
    color: 'white',
    fontWeight: 900,
  }
})(mButton);

export const AmountInput = withStyles({
  root: {
    padding: '5px 15px',
  },
  input: {
    textAlign: 'right',
    color: mainColor,
    fontSize: '2em',

  }

})(mInput)

export const TenorInput = withStyles({
  root: {
    padding: '5px 15px',
  },
  input: {
    textAlign: 'right',
    color: mainColor,
    fontSize: '2em',

  }

})(mInput)
